<template>
  <div class="receive-container">
    <!-- loading 遮罩层 -->
    <div v-if="loading" class="loading-overlay">
      <div class="loading-box">
        <div class="spinner"></div>
        <p>数据获取中...</p>
      </div>
    </div>

    <!-- 上：代理信息 -->
    <div class="card">
      <h2>代理详情</h2>
      <p class="fuw">代理编号：<strong>{{ username }}</strong></p>
    </div>

    <!-- 下：统计信息（含时间选择 + 查询按钮） -->
    <div class="card fixed-height-card">
      <h2>统计信息</h2>

      <div class="date-picker-wrapper">
        <el-date-picker
          v-model="selectedDate"
          type="date"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          placeholder="选择日期"
          style="width: 200px"
        />
        <el-button type="primary" @click="fetchData">查询</el-button>
      </div>

      <p class="stats-text">
  <!-- <span class="stat-item visits">
    访问量：<strong>{{ number }}</strong>
  </span> -->
  <span class="stat-item installs">
    安装量：<strong>{{ number2 }}</strong>
  </span>
</p>


    </div>

    <!-- 退出 -->
    <div class="exit-wrapper">
      <button @click="handleExit" class="exit-button">退出</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { ElDatePicker, ElButton } from 'element-plus'

const username = ref('')
const password = ref('')
const selectedDate = ref('')
const number = ref('')
const number2 = ref('')
const loading = ref(false)

const handleExit = () => {
  localStorage.setItem('install', null)
  localStorage.setItem('access', null)
  localStorage.setItem('update', null)
  localStorage.setItem('username', null)
  window.location.href = '/login'
}

const fetchData = async () => {

  if (!selectedDate.value) {
    alert('请选择日期')
    return
  }

  loading.value = true
  const u = localStorage.getItem('username')
  const p = localStorage.getItem('password')

  if (u === 'null' || !u) {
    window.location.href = '/login'
    return
  }

  username.value = u
  password.value = p

  try {
    const res = await axios.post(
      `api/agent/login?username=${u}&password=${p}&time=${selectedDate.value}`
    )

    if (res.data.code === '200') {
      number.value = res.data.data.access
      number2.value = res.data.data.install
    } else {
      window.location.href = '/login'
    }
  } catch (e) {
    console.error('请求失败:', e)
    window.location.href = '/login'
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  // 设置为北京时间的当天日期
  const now = new Date()
  const utc8 = new Date(now.getTime() + 8 * 60 * 60 * 1000)
  selectedDate.value = utc8.toISOString().split('T')[0]
  fetchData()
})
</script>

<style scoped>
.fuw {
  font-size: 20px;
}

.receive-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  /* min-height: 100vh; */
  position: relative;
}

.card {
  width: 100%;
  max-width: 500px;
  background: #ffffff;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  text-align: center;
}

.fixed-height-card {
  min-height: 240px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.date-picker-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 20px;
  margin-top: 20px;
}

.card h2,
.card h3 {
  color: #111827;
}

p {
  margin: 10px 0;
  color: #374151;
}

.exit-wrapper {
  margin-top: auto;
  width: 100%;
  display: flex;
  justify-content: center;
}

.exit-button {
  background-color: #ef4444;
  color: white;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  max-width: 500px;
}

.exit-button:hover {
  background-color: #dc2626;
}

/* loading 遮罩层样式 */
.loading-overlay {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-box {
  background: white;
  padding: 30px 40px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  text-align: center;
}

.spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #409eff;
  border-top-color: transparent;
  border-radius: 50%;
  margin: 0 auto 16px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.stats-text {
  text-align: center;
  margin: 0;
  padding: 12px 0;
  user-select: none;
  font-weight: 500;
  font-size: 18px;
  color: #374151;
  display: flex;
  justify-content: center;
  gap: 24px;
}

.stat-item {
  display: flex;
  align-items: center;
  padding: 12px 20px 12px 28px;
  border-radius: 12px;
  font-weight: 600;
  color: #1f2937;
  position: relative;
  box-shadow: 0 4px 12px rgb(0 0 0 / 0.1);
  min-width: 140px;
  justify-content: center;
  cursor: default;
  transition: background-color 0.3s ease;
}

.stat-item strong {
  font-size: 26px;
  margin-left: 8px;
  color: #111827;
  font-weight: 700;
  letter-spacing: 0.05em;
}

* {
  box-sizing: border-box;
}

/* 圆点装饰 */
.stat-item::before {
  content: '●';
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  font-weight: bold;
}

/* 访问量背景和点颜色 */
.visits {
  background-color: #e0e7ff; /* 淡蓝色背景 */
  color: #3730a3;
}

.visits::before {
  color: #4338ca; /* 深蓝点 */
}

/* 安装量背景和点颜色 */
.installs {
  background-color: #d1fae5; /* 淡绿色背景 */
  color: #065f46;
}

.installs::before {
  color: #047857; /* 深绿点 */
}

/* 鼠标悬停变色（可选） */
.stat-item:hover {
  background-color: #c7d2fe;
  color: #1e40af;
}
.installs:hover {
  background-color: #a7f3d0;
  color: #064e3b;
}

</style>